import React, { Component } from 'react';
import {
  Layout, Button, Icon, Modal, Tooltip, Popconfirm,
} from 'antd';
import PageWithTopbar from '../PageWithTopbar';
import UseBktGrid from '../UseBktGrid';
import ScenarioCreateModal from './ScenarioCreateModal';
import ScenarioViewEditModal from './ScenarioViewEditModal';
import {
  NO_SCENARIO_COMPARE_WHY1,
  NO_SCENARIO_COMPARE_WHY2,
  CAN_SCENARIO_COMPARE,
  DELETE_SCENARIO,
  REPLACE_PLAN,
} from '../../constants/text.constants';
import ScenarioComparisonWrapper from '../ScenarioComparison/ComparisonWrapper';

import { Main, SplitPanel, Loading } from './styles';

const getScenarioName = scenario => scenario.name.value || scenario.name;
const getScenarioComparisonTitle = selectedScenarios => selectedScenarios.map(s => getScenarioName(s)).join(' - ');

class ScenarioPageComponent extends Component {
  state = {
    modalVisible: false,
    modalTitle: '',
    modalComponent: null,
    drawerVisible: false,
  }

  showModal = (modalTitle, modalComponent) => {
    this.setState({
      modalVisible: true,
      modalTitle,
      modalComponent,
    });
  }

  setDrawerVisible = () => {
    this.setState({
      drawerVisible: true,
    });
  }

  showModalCreateScenario = () => {
    // dataView contains a list of scenarios in here.
    const { dataView: { results = [] } } = this.props;
    this.showModal(
      'Create a scenario',
      <ScenarioCreateModal onSubmit={this.handleSubmit} scenarios={[...results]} />,
    );
  }

  showViewEditScenario = (data) => {
    const { onClickToViewScenario } = this.props; // will need pushing new link to history.
    this.showModal(
      'View/Edit a scenario',
      <ScenarioViewEditModal
        onSubmit={this.handleSubmit}
        defaultData={data}
        onClickToViewScenario={onClickToViewScenario}
      />,
    );
  }

  handleSubmit = (formData, actions, isEdit) => {
    const { onSubmitToCreateScenario, onSubmitToUpdateScenario } = this.props;
    if (isEdit) {
      onSubmitToUpdateScenario(formData);
    } else {
      onSubmitToCreateScenario(formData);
    }

    this.setState({
      modalVisible: false,
    }, () => {
      actions.setSubmitting(false); // This is used to reset Formik isSubmitting prop.
    });
  }

  handleCancel = () => {
    this.setState({
      modalVisible: false,
    });
  }

  handleDrawerCancel = () => {
    this.setState({
      drawerVisible: false,
    });
  }

  handleSelect = (cell) => {
    const { onSelect } = this.props;
    const { col, rowData } = cell;

    // TODO: Better implementation required when time is less busy.
    if (col.name === 'name') {
      const defaultData = { ...rowData };
      return this.showViewEditScenario(defaultData);
    }

    return onSelect(cell);
  }

  canCompare = () => {
    const { selectedScenarios } = this.props;
    if (selectedScenarios.length !== 2) {
      return {
        tip: NO_SCENARIO_COMPARE_WHY1,
        state: true,
      };
    }

    // If is active plan, please do compare.
    if (selectedScenarios.find(d => d.id === 0)) {
      return {
        tip: CAN_SCENARIO_COMPARE,
        state: false,
      };
    }

    if (
      selectedScenarios[0].fromDate !== selectedScenarios[1].fromDate
      || selectedScenarios[0].toDate !== selectedScenarios[1].toDate
    ) {
      return {
        tip: NO_SCENARIO_COMPARE_WHY2,
        state: true,
      };
    }

    return {
      tip: CAN_SCENARIO_COMPARE,
      state: false,
    };
  }

  render() {
    const {
      meta,
      isLoading,
      dataView,
      selectedScenarios,
      gridConfigTop,
      gridConfigBottom,
      checkedState,
      onClick,
      onClickRemoveSelected,
      onClickToggleShowArchive,
      onClickSetArchiveSelected,
      onClickDeleteSelectedScenario,
      onClickReplaceActivePlan,
      onChangeSplitPanel,
      gridApi,
      updateConfig,
      lookups,
      persistParams,
      onClickToViewScenario,
    } = this.props;
    const {
      modalTitle, modalVisible, modalComponent, drawerVisible,
    } = this.state;

    const isComparable = this.canCompare();
    const emptySelection = selectedScenarios.length === 0;
    const enableSetReplace = selectedScenarios.length !== 1;
    const selectedItem = selectedScenarios.length ? selectedScenarios[0].name : '';

    const ConditionalPopConfirm = ({
      disabled, children, popTitle, okText, okType, onConfirm, ...rest
    }) => disabled
      ? <span {...rest}>{children}</span>
      : (
        <Popconfirm
          {...okText}
          {...okType}
          title={popTitle}
          onConfirm={onConfirm}
          {...rest}
        >
          {children}
        </Popconfirm>
      );

    const splitTopPanelSize = (persistParams && persistParams.scenarioSplitPaneSize)
      ? persistParams.scenarioSplitPaneSize
      : '60%';

    return (
      <Layout>
        <SplitPanel
          split="horizontal"
          defaultSize={splitTopPanelSize}
          minSize={300}
          maxSize={-80}
          onDragFinished={onChangeSplitPanel}
        >
          <Main bg="greyscale.6" onClick={onClick}>
            <PageWithTopbar
              rightComponent={(
                <Button onClick={onClickToggleShowArchive}>
                  <Icon type="eye" />
                  Toggle archived scenarios
                </Button>
              )}
              leftComponent={(
                <Button onClick={this.showModalCreateScenario}>
                  <Icon type="plus" />
                  Create scenario
                </Button>
              )}
            >
              <Loading spinning={isLoading} useupdatingtext="true" />
              <UseBktGrid
                meta={meta}
                data={dataView}
                config={gridConfigTop}
                onSelect={this.handleSelect}
                checkedState={checkedState}
                api={gridApi}
                updateConfig={updateConfig}
                noDataMessage="No scenarios in database."
                lookups={lookups}
              />
            </PageWithTopbar>
          </Main>

          <Main height="100vh">
            <PageWithTopbar
              rightComponent={(
                <Button.Group>
                  <ConditionalPopConfirm
                    placement="topLeft"
                    icon={<Icon type="warning" theme="twoTone" twoToneColor="#FFD54F" />}
                    popTitle={REPLACE_PLAN(selectedItem)}
                    okText="Confirm Replace"
                    okType="warning"
                    onConfirm={onClickReplaceActivePlan}
                    disabled={emptySelection}
                  >
                    <Button disabled={enableSetReplace}>
                      <Icon type="retweet" theme="outlined" />
                      Replace
                    </Button>
                  </ConditionalPopConfirm>
                  <Button
                    disabled={emptySelection}
                    onClick={() => onClickSetArchiveSelected(true)}
                  >
                    <Icon type="folder" />
                    Archive
                  </Button>

                  <Button
                    disabled={emptySelection}
                    onClick={() => onClickSetArchiveSelected(false)}
                  >
                    <Icon type="folder-open" />
                    Unarchive
                  </Button>
                  <ConditionalPopConfirm
                    placement="topLeft"
                    icon={<Icon type="exclamation-circle" theme="twoTone" twoToneColor="#f00" />}
                    popTitle={DELETE_SCENARIO(selectedScenarios)}
                    okText="Confirm delete"
                    okType="danger"
                    onConfirm={onClickDeleteSelectedScenario}
                    disabled={emptySelection}
                  >
                    <Button disabled={emptySelection}>
                      <Icon
                        type="delete"
                        theme={emptySelection ? 'outlined' : 'twoTone'}
                        twoToneColor="#f00"
                      />
                      Delete
                    </Button>
                  </ConditionalPopConfirm>
                </Button.Group>
              )}
              midComponent={<b>Selected scenarios</b>}
              leftComponent={(
                <Button.Group>
                  <Tooltip title={isComparable.tip} placement="topLeft">
                    <Button
                      disabled={isComparable.state}
                      onClick={this.setDrawerVisible}
                    >
                      Compare 2 scenarios
                    </Button>
                  </Tooltip>
                  <Button
                    disabled={emptySelection}
                    onClick={onClickRemoveSelected}
                  >
                    <Icon type="disconnect" />
                    Clear selection
                  </Button>
                </Button.Group>
              )}
            >
              <UseBktGrid
                meta={meta}
                data={selectedScenarios}
                config={gridConfigBottom}
                onSelect={this.handleSelect}
                noDataMessage="No selected scenarios."
              />
            </PageWithTopbar>
          </Main>
        </SplitPanel>

        <Modal
          title={modalTitle}
          maskClosable={false}
          visible={modalVisible}
          onCancel={this.handleCancel}
          footer={null}
        >
          {modalComponent}
        </Modal>
        <ScenarioComparisonWrapper
          title={getScenarioComparisonTitle(selectedScenarios)}
          selectedScenarios={selectedScenarios}
          onScenarioClick={onClickToViewScenario}
          handleDrawerCancel={this.handleDrawerCancel}
          visible={drawerVisible}
        />
      </Layout>
    );
  }
}

export default ScenarioPageComponent;
